import { call, put } from 'redux-saga/effects';
import {
    requestGetHolidays,
    requestAddHoliday,
    requestEditHoliday,
    requestDeleteHoliday,
} from '../requests/holidays';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetHolidays(action) {
    try {
        const { params, callback } = action.payload;
        const response = yield call(requestGetHolidays, params);
        if (callback) callback(response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        if (action.payload?.callback) action.payload.callback({ error: message });
        yield put(showAlert({ severity: 'error', message }));
    }
}

export function* handleAddHoliday(action) {
    try {
        const { date, name, description, callback } = action.payload;
        const response = yield call(requestAddHoliday, date, name, description);
        if (callback) callback(response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        if (action.payload?.callback) action.payload.callback({ error: message });
        yield put(showAlert({ severity: 'error', message }));
    }
}

export function* handleEditHoliday(action) {
    try {
        const { id, date, name, description, callback } = action.payload;
        const response = yield call(requestEditHoliday, id, date, name, description);
        if (callback) callback(response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        if (action.payload?.callback) action.payload.callback({ error: message });
        yield put(showAlert({ severity: 'error', message }));
    }
}

export function* handleDeleteHoliday(action) {
    try {
        const { id, callback } = action.payload;
        const response = yield call(requestDeleteHoliday, id);
        if (callback) callback(response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        if (action.payload?.callback) action.payload.callback({ error: message });
        yield put(showAlert({ severity: 'error', message }));
    }
}
